const orderTypeOptions = [
  { key: 'Hold', text: 'Hold', value: 'Hold' },
  { key: 'Pending PO', text: 'Pending PO', value: 'Pending PO' },
  { key: 'PO', text: 'PO', value: 'PO' },
  { key: 'Worksheet', text: 'Worksheet', value: 'Worksheet' }
]

export {orderTypeOptions}
